/**
 * Central helpers for reading the current browser origin.
 *
 * Everything host / subdomain / port related lives here so that the rest of
 * the app never duplicates `window.location.hostname.split('.')[0]` again.
 *
 * Local dev topology (see .env):
 *   - localhost:9002        -> subdomain "localhost" -> non-admin flows
 *   - admin.localhost:9002  -> subdomain "admin"     -> admin flows
 */

/**
 * @returns {string} lowercased first hostname segment, or "" in SSR contexts.
 */
export const getCurrentSubdomain = () => {
    if (typeof window === 'undefined' || !window.location) return '';
    return (window.location.hostname || '').split('.')[0].toLowerCase();
};

/**
 * @returns {boolean} true iff the current host is on the admin subdomain.
 */
export const isAdminHost = () => getCurrentSubdomain() === 'admin';

/**
 * @returns {boolean} true iff the current host is a local dev host.
 * Mirrors the whitelist used by `exitAdmin` in common/urlRouting.js.
 */
export const isLocalHost = () => {
    if (typeof window === 'undefined' || !window.location) return false;
    const host = window.location.host || '';
    return host.includes('localhost') || host.includes('127.0.0.1');
};
